import React from 'react';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
};

const MenuItem = ({ children, href, onClick }: Props) => {
  const linkIsExternal = href && /^https?:\/\//.test(href);

  return (
    <S.MenuItem to={href} isExternal={linkIsExternal} onClick={onClick}>
      {children} <S.Arrow />
    </S.MenuItem>
  );
};

export default MenuItem;
